/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';

import { LayoutService } from '../../../@core/utils';
import { filter, map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { UserStore } from '../../../@core/stores/user.store';
import { Tenant, TenantData } from '../../../@core/interfaces/masters/tenant';
import { environment } from '../../../../environments/environment';


import { UserData, User } from './../../../@core/interfaces/common/users';
import { NgZone } from '@angular/core';
import { Message } from '../../../@core/interfaces/patient-services/message';
import { ChatService } from '../../../@core/backend/common/services/VideoChat.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AnyARecord } from 'dns';
import { AllowIn, ShortcutEventOutput, ShortcutInput } from 'ng-keyboard-shortcuts';
import { Location } from '@angular/common';
import { PatientRegistrationData } from '../../../@core/interfaces/patient-services/patient-registration';
import { imageatch_detData } from '../../../@core/interfaces/masters/imageatch_det';
import { PhysicianData } from '../../../@core/interfaces/masters/physician-mst';
import { CookieService } from '../common/service/cookies.service';
import { BloodBankModuleData } from '../../../pages/blood-bank/backend/interface/blood-bank';
import { DateService } from '../common/service/date.service';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {
protected readonly unsubscribe$ = new Subject<void>();
  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;
  tenantDetail:Tenant;
  tenantName:any;
  selectIcon="location_on";
  Selecttext="Select Location";
  selectedLocation: any;
  ischangeBranch: boolean = false;
  onChangeBranchData: any;
  isquicksearch: boolean = false;
  patientData:any=[];
  public renewalDate=localStorage.getItem("renewalDate");
  public isSuperUser=localStorage.getItem("isSuperUser");
  public customerType=localStorage.getItem("customerType");
  showPatPortHeader: boolean = false;
  //openBookingPopUp:boolean=false;
  public regID=localStorage.getItem("regID");
  isVOPD:string = localStorage.getItem("isVOPD")

  
  callBranch(x: any): void {

    this.ischangeBranch = true;
    this.onChangeBranchData = x;  
    localStorage.removeItem("TenantHospitalImg")
    // this.selectedLocation = x;
    // this.Selecttext = this.allValue?.find(e=>e.id == localStorage.getItem("branchId")).area;

  }
  selectValue(val){

    this.Selecttext=val.area;
    localStorage.setItem("branchId",val.id);
    this.router.navigateByUrl("pages/patientservices/app").then(() => {
      window.location.reload();
    });
    this.ischangeBranch = false;
  }
  dialogNo() {
    this.selectedLocation=localStorage.getItem("branchId");
    this.Selecttext = this.allValue?.find(e=>e.id == localStorage.getItem("branchId")).area;
    this.ischangeBranch = false;
  }
  dialogOk() {
    this.selectValue(this.onChangeBranchData);
  }

private tenantId = localStorage.getItem("tenantId");
private branchId = localStorage.getItem("branchId");
private physicianId = localStorage.getItem("physicianId");

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';

  userMenu = this.getMenuItems();

  msg_count:number=0;
  private tenandId = localStorage.getItem("tenantId");
  private suserId = localStorage.getItem("userId");
  private userId:number=0;
  userName = '';
  txtMessage: string = '';
  uniqueID: string = new Date().getTime().toString();
  messages = new Array<Message>();
  message_ = new Message();
  _messages:any[]=[];
  data:any;
  flipped:boolean=false;
  uName:any;
  allValue: any = [];
  users: { name: string, title: string, id: string }[] = [];
  all_massages:any=[];
  
  shortcuts: ShortcutInput[] = [];

  srcname = "/assets/images/hospitalimg.jpeg";
  searchWord: any = '';
  lnuserName = '';//"Dr.Ram Kumar";
  lnDeptName = null;//"General Doctor";
  closeAppointmentPopUp:boolean=false;
  constructor(private sidebarService: NbSidebarService,
      private menuService: NbMenuService,
      private themeService: NbThemeService,
      private userStore: UserStore,
      private tenantSrvc:TenantData,
      private layoutService: LayoutService,
      private breakpointService: NbMediaBreakpointsService,
      protected userService: UserData,protected dateService: DateService,
      public chatService: ChatService,
      private location:Location,  private route: ActivatedRoute,
      protected patRegSrvc: PatientRegistrationData,
      private iatchSrvc: imageatch_detData, protected phySrvc: PhysicianData ,private logOutService: BloodBankModuleData,
      private _ngZone: NgZone,protected router: Router, private logoupdate:CookieService)
     {
          this.route.params.subscribe(params => {
            this.searchWord = !!params['searchWord']?params['searchWord']:''; 
          });
    if(this.router.url.includes("/patient-portal/")){
      this.showPatPortHeader=true;
    }
    else{
      this.showPatPortHeader=false;
    }

          this.logoupdate.logoUpdate$.pipe(filter(res => !!res)).subscribe(logo => {
            this.srcname=logo
          });
      }

  getMenuItems() {
    const userLink = this.user ?  '/pages/users/current-user/'+this.user.id : '';
    return [
      { title: 'Profile', link: userLink},
      
    ];
  }

  ngOnInit() {
    this.currentTheme = this.themeService.currentTheme;
    this.allValue.length = 0; 
    this.allValue = JSON.parse(localStorage.getItem("branchAccessList"));
    this.Selecttext = this.allValue?.find(e=>e.id == localStorage.getItem("branchId")).area;
    this.user = this.userStore.getUser();
    this.selectedLocation =localStorage.getItem("branchId");
    // this.Selecttext = this.allValue?.find(e=>e.id == localStorage.getItem("branchId")).area;
   this.tenantId =this.user.tenantId;
   this.loadTenantName(); 
    this.userMenu = this.getMenuItems();

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);

      this.loadImage();
      if(this.physicianId != "0")
      this.getPhysician();
      else
      this.lnuserName=this.user?.userName;
   }
  

getPhysician()
{
  this.phySrvc.getById(`${this.apiUrl}/physicians/${this.tenantId}/${this.branchId}/${this.physicianId}/GetPhyscianById`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    
    this.lnuserName =data?.displayName;
    this.lnDeptName=data?.department?.name

  }, (error) => {
  }, () => {
  });
}
  get apiUrl(): string {
    return environment.apiUrl;
  }
loadTenantName(){
  this.tenantSrvc.getById(`${this.apiUrl}/tenants/${this.tenantId}/tenantmst/${this.tenantId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    this.tenantDetail=data;
    this.tenantName=this.tenantDetail.name;
  });
}

renewalDateExpiryMessage():boolean{
  let date = new Date(this.renewalDate);
    var date1:any = new Date(date);
    var date2:any = new Date();
    let days = Math.floor((date1.getTime() - date2.getTime()) / 1000 / 60 / 60 / 24);
  if(days<=30){return true;}else{return false;}
}

loadImage(){
    //
    if(localStorage.getItem("TenantHospitalImg")==null){
      this.iatchSrvc.getById(`${environment.apiUrl}/ImageAtchDet/${this.tenantId}/${this.branchId}/all`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        
        var x =  data.filter(x=>x.phyId==null&&x.empId==null&&x.patId==null&&x.tenantId===this.tenantId && x.category=="logo")
        
        if(x.length>0)
        {
          x[0].isCreate = true;
          x[0].isEdit = true;
          this.iatchSrvc.create(`${environment.apiUrl}/ImageAtchDet/${this.tenantId}/${this.branchId}/download`,x[0]).pipe(takeUntil(this.unsubscribe$)).subscribe((downloaddata: any) => {
          this.srcname = 'data:image/jpeg;base64,' + downloaddata;
          localStorage.setItem("TenantHospitalImg", this.srcname);
        }, (error) => {

        }, () => {

        });
      }  
    }, (error) => {

    }, () => {

    });
  }else{
    this.srcname = localStorage.getItem("TenantHospitalImg");
  }
}
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.userStore.setSetting(themeName)
      .pipe(takeUntil(this.destroy$))
      .subscribe();

    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

 

  logOutUser(){
    
    let postData={
      sessionId:localStorage.getItem("sessionId"),
      tenantId:localStorage.getItem("tenantId"),
      branchId:localStorage.getItem("branchId"),
      LogOutType:"User"
    }
    this.logOutService.searchList("auth/sign-out-webApp",postData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
    }, (error) => {
    }, () => {
      
      this.router.navigateByUrl("/auth/login");
      var loggedTenantUserId=localStorage.getItem("tenantUserId");
      var loggedCustomerName=localStorage.getItem("customerName");
      var reponseTenantId=localStorage.getItem("tenantId");
      var currentUserMobileNumber=localStorage.getItem("currentUserMobileNumber");

      let userId = localStorage.getItem("wardUserId");
      let priceList = localStorage.getItem("wardWisePrice");
      localStorage.clear();
      localStorage.setItem("wardWisePrice", priceList);
      localStorage.setItem("wardUserId", userId);
    //  localStorage.setItem("skipValidTenant","false");
      localStorage.setItem("tenantUserId",loggedTenantUserId);
      localStorage.setItem('customerName',loggedCustomerName);
      localStorage.setItem('responseTenantId',reponseTenantId)
      localStorage.setItem("currentUserMobileNumber",currentUserMobileNumber);

    });
  }
  openForm() {
    document.getElementById("myForm").style.display = "block";
  }

  closeForm() {
    document.getElementById("myForm").style.display = "none";
  }


  sendMessage(event: any, userName: string, avatar: string, reply: boolean) {
    const files = !event.files ? [] : event.files.map((file) => {
      return {
        url: file.src,
        type: file.type,
        icon: 'file-text-outline',
      };
    });

    this._messages.push({
      text: event.message,
      date: new Date(),
      reply: reply,
      type: files.length ? 'file' : 'text',
      files: files,
      user: {
        name: this.uName,
        avatar: '../.././../../assets/images/userav.png',
      },
    });

      this.message_ = new Message();
      this.message_.clientuniqueid = this.uniqueID;
      this.message_.type = "sent";
      this.message_.message = event.message;// this.txtMessage;
      this.message_.date = new Date();
      this.message_.userId=this.userId+","+this.suserId;//.toString();
      this.message_.tenantId=this.tenandId;
      this.message_.userName=this.uName;
      this.message_.chatType='';
      this.messages.push(this.message_);
      var data=this.all_massages;
      if(this.all_massages.length==0){
        this.all_massages.push({'id':this.userId,'message':this._messages});
      }else{
        var ii;
        var data;
        for(var i=0;i<this.all_massages.length;i++){
          if(this.all_massages[i].id==this.userId) {
            ii=i;
            data=this.all_massages[i].message
          }
         }
        var data=this.all_massages.filter(e => e.id === this.userId);
            if(data.length==0){
              this.all_massages.push({'id':this.userId,'message':this._messages});
            }else{
               if(ii!=null) {
                 var data_=this._messages;
                this.all_massages[ii].message=data_;
                var data1=this.all_massages[ii].message;
                this._messages=data1;
               }
            }
     }
     this.setMessages(this.all_massages);
      this.txtMessage = '';


  }

  toggleView() { this.flipped = !this.flipped; }

  chatUser(user){
    this.msg_count=0;
    this._messages=[];
    this.userName=user.name;
    this.userId=user.id;
    this.toggleView();
    for (var i=0;i<this.all_massages.length;i++) {
          if(this.all_massages[i].id==user.id){
            this.mesage_set(user.id,0)
            var data=this.all_massages[i].message;
            this._messages=data;
          }
        }
  }
  sendMessage1(): void {
    if (this.txtMessage) {
      this.message_ = new Message();
      this.message_.clientuniqueid = this.uniqueID;
      this.message_.type = "sent";
      this.message_.message = this.txtMessage;
      this.message_.date = new Date();
      this.messages.push(this.message_);
      this.txtMessage = '';
    }
  }
  private subscribeToEvents(): void {
    
  }

  reorderUserlist(userId){

    var users=[];
    for(var i=0;i<this.users.length;i++){
      if(userId==this.users[i].id) {
        users.push(this.users[i]);
      }
    }

    for(var j=0;j<this.users.length;j++){
      if(userId!=this.users[j].id) {
        users.push(this.users[j]);
      }
    }
    this.users=users;
  }

  setMessages(data:any){
    window.localStorage.setItem("msg",JSON.stringify(data));
  }
  getMessages(){
    return JSON.parse(window.localStorage.getItem("msg"));
  }
  getUser(id){
    var data=this.users.filter(e => e.id === id);
    return data[0];
  }

  fetchUsertype() {
    if(this.getMessages()!=null){
      this.all_massages=this.getMessages();
    }

    this.users=[];
    this.userService.userList(`users/userlist/${this.tenandId}`).pipe(takeUntil(this.unsubscribe$)).subscribe((datas: any) => {
      this.data = datas;
      for(var i=0;i<datas.length;i++){
        if(parseInt(this.suserId)===datas[i].id){
          this.userName=datas[i].firstName+" "+datas[i].lastName;
          this.uName=this.userName;
	        this.userId=datas[i].id;
        }else{
          this.users.push({name: datas[i].firstName+" "+datas[i].lastName, title: '0', id: datas[i].id})
        }
      }

    }, (error) => {

    }, () => {

    });
  }

  mesage_set(id,count){
    for(var i=0;i<this.users.length;i++){
      if(this.users[i].id==id){
          this.users[i].title=count;
      }
    }
  }
  ngAfterViewInit(): void {
    this.shortcuts.push(
      {
        key: "shift + b",
        preventDefault: true,
        allowIn: [AllowIn.Textarea, AllowIn.Input],
        command: (output: ShortcutEventOutput) => this.location.back() ,
      },   
      {
        key: "shift + f",
        preventDefault: true,
        allowIn: [AllowIn.Textarea, AllowIn.Input],
        command: (output: ShortcutEventOutput) => this.location.forward() ,
      },      
    );
  }

  searchCallPatient(){
    if(!!this.searchWord){   
    this.router.navigate(['/pages/patientsearch/'+this.searchWord]);
    this.searchWord=''
 }
   
  }
  searchpatient(){

    var searchData={
      "searchWord":this.searchWord,
      "fromDate": null,
      "toDate": null,
      "skip": 0,
      "take": 100
    };
    this.patRegSrvc.searchList("patientregistrationmst/" + this.tenandId + '/' + this.branchId + '/search', searchData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      if(data.length>0){
        this.patientData=data;
        // this.isquicksearch=true;
      }
      // this.patRegSrvc.setPatientSearchData({searchWord:this.searchWord,datas:data});
    },
    (error) => {     
    },
    () => { 
      this.router.navigate(['/pages/patientsearch/'+this.searchWord]);
    });

    
  }
  closeQS(){
    // this.isquicksearch=false;
  }

  openBookingPopUp(){
    this.router.navigate(['/pages/patient-portal/booking-newpage/fromPortal' ]);
  }
}
